import $axios from 'axios';

export const publicAxios = $axios.create();

publicAxios.defaults.headers['Accept-Language'] = 'en';
publicAxios.defaults.headers['ngrok-skip-browser-warning'] = 'false';
publicAxios.defaults.headers.post['Content-Type'] = 'application/json';
publicAxios.defaults.baseURL = import.meta.env.VITE_API_URL + '/api/v1/';
publicAxios.defaults.withCredentials = true;
